import React from 'react';

export default function PieChart({ data, size = 180 }) {
  const total = data.reduce((sum, d) => sum + d.value, 0);
  if (total === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <svg width={size} height={size} viewBox="0 0 180 180">
          <circle cx="90" cy="90" r="70" fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="24" />
          <text x="90" y="85" textAnchor="middle" fill="rgba(255,255,255,0.2)" fontSize="12" fontWeight="600">No Income</text>
          <text x="90" y="102" textAnchor="middle" fill="rgba(255,255,255,0.15)" fontSize="10">Yet</text>
        </svg>
      </div>
    );
  }

  const radius = 70;
  const circumference = 2 * Math.PI * radius;
  let cumulativeOffset = 0;

  return (
    <div style={{ textAlign: 'center' }}>
      <svg width={size} height={size} viewBox="0 0 180 180" style={{ transform: 'rotate(-90deg)' }}>
        {data.map((segment, i) => {
          if (segment.value === 0) return null;
          const segmentLength = (segment.value / total) * circumference;
          const offset = cumulativeOffset;
          cumulativeOffset += segmentLength;
          return (
            <circle
              key={i}
              cx="90" cy="90" r={radius}
              fill="none"
              stroke={segment.color}
              strokeWidth="24"
              strokeDasharray={`${segmentLength} ${circumference - segmentLength}`}
              strokeDashoffset={-offset}
              strokeLinecap="round"
              style={{
                filter: `drop-shadow(0 0 4px ${segment.color}40)`,
                animation: `pieSliceIn 0.8s ease-out ${i * 0.1}s both`
              }}
            />
          );
        })}
      </svg>
      <style>{`
        @keyframes pieSliceIn {
          from { opacity: 0; stroke-width: 0; }
          to { opacity: 1; stroke-width: 24; }
        }
      `}</style>
    </div>
  );
}
